import { createBrowserHistory, createMemoryHistory } from 'history';
import { DigitalDataStrategy, AnalyticsMgr, BCManager, GBDManager, IVMgr, CoreFlagMgr } from '@nab/nab-x-sdk-browser';
const createAnalyticsMgr = ({ strategy = null }) => new AnalyticsMgr(strategy || new DigitalDataStrategy());
const createDataSecurityMgr = ({ iv: { LibraryUrl: ivLib, configValue: ivConfig } = { LibraryUrl: '' }, gbd: { LibraryUrl: gbdLib, configValue: gbdConfig } = { LibraryUrl: '' }, bc: { LibraryUrl: bcLib, configValue: bcConfig } = { LibraryUrl: '' } }) => ({
    bc: new BCManager(bcLib, bcConfig),
    gbd: new GBDManager(gbdLib, gbdConfig),
    iv: new IVMgr(ivLib, ivConfig)
});
const createFlagMgr = ({ strategy = null }) => {
    const flagMgr = new CoreFlagMgr();
    return flagMgr;
};
export const defaultServicesProvider = (servicesConfig) => {
    const analyticsMgr = createAnalyticsMgr((servicesConfig && servicesConfig.analytics) || {});
    const dataSecurityMgr = createDataSecurityMgr((servicesConfig && servicesConfig.dataSecurity) ||
        { iv: { LibraryUrl: '' }, gbd: { LibraryUrl: '' }, bc: { LibraryUrl: '' } });
    const flagMgr = createFlagMgr((servicesConfig && servicesConfig.flags) || {});
    const history = servicesConfig?.history?.suppressRouting
        ? createMemoryHistory()
        : createBrowserHistory({
            basename: servicesConfig?.history?.routingBasePath || ''
        });
    return {
        analyticsMgr,
        dataSecurityMgr,
        flagMgr,
        history
    };
};
//# sourceMappingURL=defaultServicesProvider.js.map